import { CommonHttpService } from './http.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';

@Injectable()
export class CartItemsService {
    constructor(
        protected http: CommonHttpService
    ) {}

    /**
     * This call API to index all cart items.
     **/
    public index(): Observable<Response> {
        return this.http
            .get('/checkout/cart/items');
    }

    /**
     * This call API to remove a cart item by item id.
     **/
    public remove(rowId, id, type: string): Observable<Response> {
        return this.http
            .get(`/checkout/cart/${type}/remove/${id}?row_id=${rowId}`);
    }

    /**
     * This call API to update a cart item quantity by item id.
     **/
    public update(rowId, id, type: string, quantity = 1): Observable<Response> {
        return this.http
            .get(`/checkout/cart/${type}/update/${id}?row_id=${rowId}&quantity=${quantity}`);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/shared/services/cart-items.service.ts